var map = {
	"./penguin 2.jpg": 45187,
	"./penguin.jpg": 44177,
	"./rabbit  4.jpg": 17053,
	"./rabbit 01.jpg": 31636,
	"./rabbit 07.jpg": 56130,
	"./rabbit 08.jpg": 69049,
	"./rabbit 09.jpg": 24700,
	"./rabbit 6.jpg": 53203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57663;